import { render } from "./ctms_contract_frame_info.vue?vue&type=template&id=5a68e54e"
import script from "./ctms_contract_frame_info.vue?vue&type=script&lang=js"
export * from "./ctms_contract_frame_info.vue?vue&type=script&lang=js"

import exportComponent from "D:\\svn\\esp-rms-xhjr-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__